export default __webpack_public_path__ + "static/media/38_mobile.0585b941.jpeg";